/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, centerAbsolutely, imageTypes, animations, mediaQuery, backgrounds, spacing, heights } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LOADING STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    uniquecontent: {
    	'& .contentindicator, .pointindicator': {
    		display: 'none'
    	},
    	'& .frame.type-loading': {
    		position: 'relative'
    	},
    	'& .background': {
    		'& .fade': {
    			background: `${backgrounds.gray} !important`
    		}
	    },
        '& .title': {
    	    marginTop: pxToEm(35),
            marginBottom: pxToEm(10),
            '& h2': {
                opacity: 0,
                animationName: 'fadeIn',
                animationDuration: '2s',
                animationDelay: '1.5s',
                animationFillMode: 'forwards',
            }
        },
        '& .bodycopy': {
    	  '& p': {
              opacity: 0,
              animationName: 'fadeIn',
              animationDuration: '2s',
              animationDelay: '1.7s',
              animationFillMode: 'forwards',
          }
        },
    	'& .loading': {
			paddingTop: pxToEm(25),
	    	textAlign: 'center',
	        width: '100%',
            '& .logo': {
                position: 'absolute',
                top: heights.header,
                left: pxToEm(15),
                fontSize: '150%',
                margin: '-52px 0 0 -10px'
            },
            '& .loader': {
                marginBottom: pxToEm(10)
            },
            '& .bodycopy': {
                textAlign: 'center'
            }
	    },
        '& .footer': {
            '& .skip' : {
                display: 'none'
            }
        }
    }
};
